import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import ProcessingBar2 from "../../../components/ProcessingBar/ProcessingBar2";

const ContactCard = ({
  title,
  description,
  buttonText,
  onClick,
  showProcessing,
}) => {
  return (
    <div className="group relative flex-1 min-w-[280px] bg-redlight text-text rounded-3xl p-6 transition-all duration-300 ease-in-out shadow-md">
      <h3 className="text-xl font-semibold mb-4">{title}</h3>
      <p className="text-sm opacity-90 mb-10 transition-all duration-300 group-hover:opacity-100 group-hover:mb-4 text-border">
        {description}
      </p>

      <div className="absolute bottom-4 right-6 mt-2">
        <button
          onClick={onClick}
          className="flex items-center justify-center bg-dry text-redlight text-sm font-medium rounded-full h-10 px-4 transition-all duration-300 overflow-hidden whitespace-nowrap group-hover:px-6"
        >
          {showProcessing ? (
            <div className="flex items-center justify-center w-full h-full min-w-[80px]">
              <ProcessingBar2 />
            </div>
          ) : (
            <>
              <ArrowRightIcon className="w-5 h-5 block group-hover:hidden transition-all duration-300" />
              <span className="hidden group-hover:block transition-all duration-300">
                {buttonText}
              </span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

const GetInTouchSection = () => {
  const navigate = useNavigate();
  const [showProcessingHelp, setShowProcessingHelp] = useState(false);
  const [showProcessingRegister, setShowProcessingRegister] = useState(false);

  const handleHelp = () => {
    setShowProcessingHelp(true);
    setTimeout(() => {
      setShowProcessingHelp(false);
      navigate("/help-center");
    }, 2000);
  };

  const handleRegister = () => {
    setShowProcessingRegister(true);
    setTimeout(() => {
      setShowProcessingRegister(false);
      navigate("/register");
    }, 2000);
  };

  return (
    <section className="py-32 px-4 md:px-12 bg-dry">
      <div className="text-center my-12" data-aos="fade-up">
        <h2 className="text-4xl font-serif text-text">Get in touch</h2>
        <p className="text-textGray">
          Want to get in touch? We’d love to hear from you. Here’s how you can
          reach us.
        </p>
      </div>
      <div className="w-16 h-1 bg-red-500 mx-auto mb-8" data-aos="fade-up" />

      <div
        className="flex flex-col md:flex-row gap-6 transition-all max-w-5xl mx-auto"
        data-aos="fade-up"
      >
        <ContactCard
          title="Need help with Lokalai?"
          description="Find answers in our help centre or contact us directly."
          buttonText="Support"
          onClick={handleHelp}
          showProcessing={showProcessingHelp}
        />
        <ContactCard
          title="Talk to the sales team"
          description="Chat with our sales team to get 30-day free trial."
          buttonText="Let's talk"
          onClick={handleRegister}
          showProcessing={showProcessingRegister}
        />
      </div>
    </section>
  );
};

export default GetInTouchSection;
